import React from 'react'

import { fmtCount } from '../helpers/helper'

// Summary row above the table. While loading each tile shows an ellipsis rather than a
// stale or zero number, so the tiles never briefly assert something untrue.
const StatTiles = ({ data, loading }) => {
  // Summed client-side because the API's `totals` carries no 24h figure. A mailbox that
  // timed out contributes null (counted as 0 here) while its own row still renders an em
  // dash — so the tile under-reports rather than hiding the degradation inside a total.
  const items = (data && data.items) || []
  const sentLast24h = items.reduce((sum, item) => sum + (item.sentToday || 0), 0)
  const totals = (data && data.totals) || {}

  const tiles = [
    { key: 'sent_24h', label: 'Sent last 24h', value: data ? sentLast24h : null },
    { key: 'sent', label: 'Total sent', value: totals.sent },
    { key: 'inbox', label: 'Total inbox', value: totals.inbox },
    { key: 'unseen', label: 'Total unread', value: totals.unseen },
    { key: 'mailboxes', label: 'Mailboxes', value: data ? data.total : null },
  ]

  return (
    <div className='am-tiles'>
      {tiles.map((tile) => (
        <div
          key={tile.key}
          className='am-tile'
        >
          <div className='am-tile-value'>{loading ? '…' : fmtCount(tile.value)}</div>
          <div className='am-tile-label'>{tile.label}</div>
        </div>
      ))}
    </div>
  )
}

export default StatTiles
